import { configureStore, Middleware } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import { argoApi } from "./api/argoApi";
import { createPersistedReducer } from "./reducers";

function getUserIdFromStorage(): string {
  try {
    const userRaw = localStorage.getItem("user");

    if (!userRaw) return "guest";

    const parsed = JSON.parse(userRaw);
    const id = parsed?.id;

    return id ? String(id) : "guest";
  } catch {
    return "guest";
  }
}

const userId = getUserIdFromStorage();

export function createAppStore(userId: string) {
  const store = configureStore({
    reducer: createPersistedReducer(userId),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(argoApi.middleware as Middleware),
  });

  const persistor = persistStore(store);

  return { store, persistor };
}

export const { store, persistor } = createAppStore(userId);

export type AppDispatch = typeof store.dispatch;
